import React, { Component } from 'react';
import { isEmpty } from '../../../Common/Common';

export default class Total_Water_Consumption extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
		let card_style = {
			overflow: 'auto',
			width: this.props.width - 40,
			marginLeft: 'auto',
			marginRight: 'auto',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			borderRadius: 20,
			paddingBottom: 10,
			marginTop: 20,
		}

		let row_style = {
			background: 'white',
			padding: '0px 10px',
			width: this.props.width - 60,
			marginLeft: 'auto',
			marginRight: 'auto',
			marginTop: 10,
			textAlign: 'left',
		}

		let day_data = 0;
		let month_data = 0;

		if (!isEmpty(this.props.data.water_consumption)) {
			if (this.props.data.water_consumption.day != null) day_data = this.props.data.water_consumption.day;
			if (this.props.data.water_consumption.month != null) month_data = this.props.data.water_consumption.month;
		}

		return (
			<div style={card_style}>
				<div style={{ textAlign: 'left', marginLeft: 10 }}>
					<span className="header">{this.props.receiver.getString('total_water_consumption')}</span>
				</div>
				<div style={row_style}>
					<div style={{ display: 'inline-block', width: this.props.width - 210 }}>
						<span>{this.props.receiver.getString('today')}</span>
					</div>
					<div style={{ display: 'inline-block', width: 150, textAlign: 'right' }}>
						<span>{day_data + ' m³'}</span>
					</div>
				</div>
				<div style={row_style}>
					<div style={{ display: 'inline-block', width: this.props.width - 210 }}>
						<span>{this.props.receiver.getString('this_month')}</span>
					</div>
					<div style={{ display: 'inline-block', width: 150, textAlign: 'right' }}>
						<span>{month_data + ' m³'}</span>
					</div>
				</div>
			</div>
		)
	}
}